export const lang = [
  {
    text: "English",
    value: "EN",
    flag: "gb",
  },
  {
    text: "Arabic",
    value: "AR",
    flag: "eg",
  },
  {
    text: "French",
    value: "FR",
    flag: "fr",
  },
];
export const countries = [
  {
    text: "Egypt",
    value: "EG",
    currency: "EGP",
    currencyAr: "جنيه مصري",
    flag: "eg",
    operator: [
      {
        text: "Vodafone",
        textAr: "فودافون",
        operatorCode: "60202",
        shortcode: "6699",
        placeholder: "+20-10-xxxx-xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
      {
        text: "Etisalat",
        textAr: "اتصالات",
        operatorCode: "60203",
        shortcode: "1722",
        placeholder: "+20-11-xxxx-xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
      {
        text: "Orange",
        textAr: "اورانج",
        operatorCode: "60201",
        shortcode: "5030",
        placeholder: "+20-12-xxxx-xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
      {
        text: "WE",
        textAr: "وي",
        operatorCode: "60204",
        shortcode: "4041",
        placeholder: "+20-15-xxxx-xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
    ],
  },
  {
    text: "United Arab Emirates",
    value: "UAE",
    currency: "AED",
    currencyAr: "درهم",
    flag: "uae",
    operator: [
      {
        text: "Etisalat",
        textAr: "اتصالات",
        operatorCode: "60203",
        shortcode: "1151",
        placeholder: "05x xxx xxxx",
        disclaimeravailablity: false,
        isVat: true,
        isTerms: true,
        isExit: true,
        isUpDisc: true,
        isdownDisc: true,
      },
      {
        text: "DU",
        textAr: "دو",
        operatorCode: "60201",
        shortcode: "2884",
        placeholder: "05x xxx xxxx",
        disclaimeravailablity: false,
        isVat: true,
        isTerms: true,
        isExit: true,
        isUpDisc: true,
        isdownDisc: true,
      },
    ],
  },
  {
    text: "Qatar",
    value: "QA",
    currency: "QAR",
    currencyAr: "ريال قطري",
    flag: "qa",
    operator: [
      {
        text: "Ooredoo",
        textAr: "أوريدو",
        operatorCode: "42701",
        shortcode: "92413",
        placeholder: "974x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
      {
        text: "Vodafone",
        textAr: "فودافون",
        operatorCode: "42702",
        shortcode: "97814",
        placeholder: "974x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
    ],
  },
  {
    text: "Saudi Arabia",
    value: "KSA",
    currency: "SAR",
    currencyAr: "ريال سعودي",
    flag: "ksa",
    operator: [
      {
        text: "Mobily",
        textAr: "موبايلي ",
        operatorCode: "42003",
        shortcode: "",
        placeholder: "966x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
      {
        text: "stc",
        textAr: "stc",
        operatorCode: "42001",
        shortcode: "",
        placeholder: "966x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
      {
        text: "Zain",
        textAr: "زين",
        operatorCode: "42004",
        shortcode: "708900",
        placeholder: "965x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
    ],
  },
  {
    text: "Jordan",
    value: "JO",
    currency: "JOD",
    currencyAr: "دينار أردني ",
    flag: "jo",
    operator: [
      {
        text: "Orange",
        textAr: "اورانج ",
        operatorCode: "41677",
        shortcode: "99222",
        placeholder: "962x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
      {
        text: "Umniah",
        textAr: "أمنية",
        operatorCode: "41603",
        shortcode: "91825",
        placeholder: "962x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
      {
        text: "Zain",
        textAr: "زين",
        operatorCode: "41601",
        shortcode: "97970",
        placeholder: "962x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
    ],
  },
  {
    text: "Kuwait",
    value: "KU",
    currency: "KWD",
    currencyAr: "دينار كويتي ",
    flag: "ku",
    operator: [
      //  {
      //    text: "Ooredoo",
      //    textAr: "أوريدو ",
      //    operatorCode: "41903",
      //    shortcode: "1634",
      //    placeholder: "965x xxx xxxx",
      //    disclaimeravailablity: true,
      //    isVat: false,
      //    isTerms: false,
      //    isExit: false,
      //    isUpDisc: false,
      //    isdownDisc: false,
      //  },
      {
        text: "stc",
        textAr: "stc",
        operatorCode: "41904",
        shortcode: "50471",
        placeholder: "965x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
      {
        text: "Zain",
        textAr: "زين",
        operatorCode: "41902",
        shortcode: "94010",
        placeholder: "965x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: false,
      },
    ],
  },
  {
    text: "Libya",
    value: "LY",
    currency: "LYD",
    currencyAr: "دينار ليبي ",
    flag: "ly",
    operator: [
      {
        text: "Libyana",
        textAr: "ليبيانا ",
        operatorCode: "60600",
        shortcode: "15632",
        placeholder: "218x xxx xxxx",
        disclaimeravailablity: true,
        isVat: true,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
    ],
  },
  {
    text: "Iraq",
    value: "IQ",
    currency: "IQD",
    currencyAr: "دينار عراقي  ",
    flag: "iq",
    operator: [
      {
        text: "Zain",
        textAr: "زين ",
        operatorCode: "41830",
        shortcode: "92413",
        placeholder: "964x xxx xxxx",
        disclaimeravailablity: true,
        isVat: true,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
      // {
      //   text: "AsiaCell",
      //   textAr: "آسياسيل‎ ",
      //   operatorCode: "41805",
      //   shortcode: "3760",
      //   placeholder: "964x xxx xxxx",
      //   disclaimeravailablity: true,
      //   isVat: true,
      //   isTerms: false,
      //   isExit: false,
      //   isUpDisc: false,
      //   isdownDisc: true,
      // },
    ],
  },
  {
    text: "Oman",
    value: "OM",
    currency: "OMR",
    currencyAr: "ريال عماني ",
    flag: "om",
    operator: [
      {
        text: "Ooredoo",
        textAr: "أوريدو ",
        operatorCode: "42203",
        shortcode: "91230",
        placeholder: "968x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
      // {
      //   text: "Omantel",
      //   textAr: "عمانتل ",
      //   operatorCode: "42202",
      //   shortcode: "70080",
      //   placeholder: "968x xxx xxxx",
      //   disclaimeravailablity: true,
      //   isVat: true,
      //   isTerms: false,
      //   isExit: false,
      //   isUpDisc: false,
      //   isdownDisc: true,
      // },
    ],
  },
  {
    text: "Palestine",
    value: "PS",
    currency: "ILS",
    currencyAr: "شيكل  ",
    flag: "ps",
    operator: [
      {
        text: "Jawwal",
        textAr: "جوال ",
        operatorCode: "42505",
        shortcode: "37095",
        placeholder: "970x xxx xxxx",
        disclaimeravailablity: true,
        isVat: true,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
      {
        text: "Ooredoo",
        textAr: "أوريدو ",
        operatorCode: "42506",
        shortcode: "7825",
        placeholder: "970x xxx xxxx",
        disclaimeravailablity: true,
        isVat: true,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
    ],
  },
  {
    text: "Tunisia ",
    value: "TN",
    currency: "TND",
    currencyAr: "دينار تونسي ",
    flag: "tn",
    operator: [
      {
        text: "Ooredoo",
        textAr: "أوريدو ",
        operatorCode: "60503",
        shortcode: "85552",
        placeholder: "216x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
      {
        text: "Orange",
        textAr: "اورانج ",
        operatorCode: "60501",
        shortcode: "85560",
        placeholder: "216x xxx xxxx",
        disclaimeravailablity: true,
        isVat: false,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
    ],
  },
  {
    text: "Algeria ",
    value: "AL",
    currency: "DZD",
    currencyAr: "دينار جزائري ",
    flag: "al",
    operator: [
      {
        text: "Ooredoo",
        textAr: "أوريدو ",
        operatorCode: "60303",
        shortcode: "50015",
        placeholder: "213x xxx xxxx",
        disclaimeravailablity: true,
        isVat: true,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
    ],
  },
  {
    text: "Bahrain ",
    value: "BH",
    currency: "BHD",
    currencyAr: "دينار بحريني ",
    flag: "bh",
    operator: [
      {
        text: "stc",
        textAr: "stc ",
        operatorCode: "42604",
        shortcode: "98726",
        placeholder: "973x xxx xxxx",
        disclaimeravailablity: true,
        isVat: true,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
      {
        text: "Zain",
        textAr: "زين ",
        operatorCode: "42602",
        shortcode: "94005",
        placeholder: "973x xxx xxxx",
        disclaimeravailablity: true,
        isVat: true,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
      {
        text: "Batelco",
        textAr: "بتلكو  ",
        operatorCode: "42601",
        shortcode: "94466",
        placeholder: "973x xxx xxxx",
        disclaimeravailablity: true,
        isVat: true,
        isTerms: false,
        isExit: false,
        isUpDisc: false,
        isdownDisc: true,
      },
    ],
  },
];
